import { RevealOnScroll } from "./Reveal";
import { CONTATTI, FOOTER } from "@/constants/testIds";
import { SITE } from "@/data/siteData";
import { Phone, Clock, Instagram, Facebook } from "lucide-react";

const Contatti = () => {
    return (
        <section
            id="contatti"
            data-testid={CONTATTI.section}
            className="relative bg-[#E63946] text-white pt-20 md:pt-28 pb-10 overflow-hidden"
        >
            <div className="px-5 md:px-10 lg:px-14 max-w-[1600px] mx-auto">
                <span className="text-xs md:text-sm uppercase tracking-[0.3em] font-bold text-[#FFD600]">
                    · Contatti
                </span>

                <RevealOnScroll delay={0.05}>
                    <h2 className="font-display uppercase leading-[0.82] tracking-tighter text-[22vw] md:text-[14vw] lg:text-[12vw] mt-3">
                        Chiama
                        <br />
                        <span className="italic font-serif-editorial text-[#FFD600] normal-case tracking-tight">
                            adesso.
                        </span>
                    </h2>
                </RevealOnScroll>

                <RevealOnScroll delay={0.1}>
                    <p className="mt-4 md:-mt-2 md:mb-4 text-lg md:text-2xl font-serif-editorial italic text-white/90">
                        {SITE.reservationNote}.
                    </p>
                </RevealOnScroll>

                <div className="mt-12 md:mt-16 grid md:grid-cols-12 gap-8 md:gap-10 border-t-2 border-white/40 pt-10">
                    <div className="md:col-span-5">
                        <p className="uppercase tracking-[0.3em] text-xs font-bold text-[#FFD600]">
                            Chiama
                        </p>
                        <a
                            href={`tel:${SITE.phoneRaw}`}
                            data-testid={CONTATTI.phone}
                            className="block mt-3 font-display text-5xl md:text-6xl leading-none hover:text-[#FFD600] transition-colors duration-300"
                        >
                            {SITE.phone}
                        </a>

                        <div className="mt-8 flex flex-wrap gap-3">
                            <a
                                href={`tel:${SITE.phoneRaw}`}
                                className="hard-shadow-sm inline-flex items-center gap-3 px-5 py-3 rounded-full bg-white text-[#0a0a0a] border-2 border-[#0a0a0a] font-bold uppercase tracking-widest text-sm"
                            >
                                <Phone className="w-4 h-4" strokeWidth={2.5} /> Prenota per Telefono
                            </a>
                            <a
                                href={`https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(
                                    "Ciao! Vorrei prenotare da Senso Unico.",
                                )}`}
                                target="_blank"
                                rel="noreferrer"
                                data-testid={CONTATTI.whatsapp}
                                className="hard-shadow-sm inline-flex items-center gap-3 px-5 py-3 rounded-full bg-[#0a0a0a] text-white border-2 border-[#0a0a0a] font-bold uppercase tracking-widest text-sm"
                            >
                                WhatsApp
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-7">
                        <p className="uppercase tracking-[0.3em] text-xs font-bold text-[#FFD600] flex items-center gap-2">
                            <Clock className="w-3.5 h-3.5" /> Orari di Apertura
                        </p>
                        <ul
                            data-testid={CONTATTI.hours}
                            className="mt-4 divide-y divide-white/25 border-y border-white/25"
                        >
                            {SITE.hours.map((h) => {
                                const closed = h.value === "Chiuso";
                                return (
                                    <li
                                        key={h.day}
                                        className="flex items-baseline justify-between py-3"
                                    >
                                        <span className="font-display uppercase text-2xl md:text-3xl">
                                            {h.day}
                                        </span>
                                        <span
                                            className={`font-body text-base md:text-lg tabular-nums ${
                                                closed ? "text-[#FFD600]" : "text-white/90"
                                            }`}
                                        >
                                            {h.value}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>

                <footer
                    data-testid={FOOTER.section}
                    className="mt-14 md:mt-20 border-t-2 border-white/40 pt-8 pb-2 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
                >
                    <div className="flex items-center gap-3">
                        <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-white text-[#E63946] font-display text-lg">
                            S
                        </span>
                        <span className="font-display text-xl uppercase">
                            Senso Unico · Pizzeria
                        </span>
                    </div>
                    <div className="flex items-center gap-5 text-sm">
                        <a
                            href="https://www.facebook.com/"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-2 hover:text-[#FFD600]"
                        >
                            <Facebook className="w-4 h-4" /> Facebook
                        </a>
                        <a
                            href="https://www.instagram.com/"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-2 hover:text-[#FFD600]"
                        >
                            <Instagram className="w-4 h-4" /> Instagram
                        </a>
                    </div>
                    <div className="text-xs uppercase tracking-[0.25em] text-white/70">
                        © {new Date().getFullYear()} · Castel d&apos;Ario, Mantova
                    </div>
                </footer>
            </div>
        </section>
    );
};

export default Contatti;
